import {Component, Input} from '@angular/core';
import {RunOutcomeView} from '../value-review.model';

/** One "what the run does with this value" line: an icon for the tone, the
 * outcome, and an optional second line. */
@Component({
  selector: 'app-run-outcome',
  templateUrl: './run-outcome.component.html',
  styleUrls: ['./run-outcome.component.scss'],
  standalone: false,
})
export class RunOutcomeComponent {
  @Input({required: true}) view!: RunOutcomeView;

  get icon(): string {
    switch (this.view.tone) {
      case 'ok':
        return 'check';
      case 'warn':
        return 'warning_amber';
      default:
        return 'block';
    }
  }
}
